export const formatWallClockDateTime = (
  value: string | null | undefined,
): string => {
  const raw = String(value || "").trim();
  if (!raw) return "Слот не выбран";

  const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}):(\d{2})/);
  if (!match) return raw;

  const [, year, month, day, hour, minute] = match;
  return `${day}.${month}.${year}, ${hour}:${minute}`;
};

export const formatWallClockRange = (
  startValue: string | null | undefined,
  endValue: string | null | undefined,
): string => {
  const start = formatWallClockDateTime(startValue);
  if (!endValue) return start;

  const endRaw = String(endValue || "").trim();
  const endMatch = endRaw.match(/^(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}):(\d{2})/);
  if (!endMatch) return start;

  return `${start} — ${endMatch[4]}:${endMatch[5]}`;
};
